import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals.ts";
import { BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import { createRoot } from 'react-dom/client';
import { createStore, applyMiddleware, Middleware } from "redux";
import { thunk } from "redux-thunk";
import { Provider, useDispatch } from "react-redux";
import reducers from "./redux/reducers/index.ts";
import logger from "redux-logger";

// เพิ่ม imports สำหรับ redux-persist
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // ใช้ localStorage
import { PersistGate } from "redux-persist/integration/react";

// เพิ่ม React Query
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./utils/queryClient.ts";

// กำหนดค่าสำหรับ persist - ระบุให้เก็บเฉพาะ AuthReducer
const persistConfig = {
  key: "root", // key ที่ใช้เก็บใน localStorage
  storage,
  // เก็บเฉพาะ AuthReducer เท่านั้น
  whitelist: ['AuthReducer'] // สมมติว่า reducer ชื่อ 'auth' - ปรับตามชื่อจริงที่คุณใช้
};

// สร้าง persisted reducer
const persistedReducer = persistReducer(persistConfig, reducers);

let middlewares: Middleware[] = [thunk];

if (process.env.REACT_APP_IS_PRODUCTION !== "1") {
  middlewares.push(logger);
}

export const history = createBrowserHistory();

// ใช้ persistedReducer แทน reducers
export const store = createStore(persistedReducer, applyMiddleware(...middlewares));
// สร้าง persistor
export const persistor = persistStore(store);

// reference
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </QueryClientProvider>
    </Provider>
  </BrowserRouter>
); 

reportWebVitals();